import types from './types';

const defaultState = {
  isReportLoading: false
};

export default (state = defaultState, { type }) => {
  switch (type) {
    case types.GET_REPORT:
    case types.GET_CSV_REPORT:
      return { ...state, isReportLoading: true };

    case types.GET_CSV_REPORT_FAILURE:
    case types.GET_CSV_REPORT_SUCCESS:
    case types.GET_REPORT_FAILURE:
    case types.GET_REPORT_SUCCESS:
      return { ...state, isReportLoading: false };
    default:
      return state;
  }
};
